import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import "./stampingCapabilities.css"
import logoStamping from "../../imagens/logos/logoStamping.png"
import { Link } from 'react-router-dom'



function StampingCapabilities({ listStamping }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handleOpenModal = (index) => {
        setOpenModal(true)
        setSlideNumber(index)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listStamping.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listStamping.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listStamping.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listStamping.length])


    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>

            {
                openModal &&
                <div className='stampingSliderWrap'>
                    <FontAwesomeIcon className='stampingBtnPrev' icon={faCircleChevronLeft} onClick={prevSlide} />
                    <FontAwesomeIcon className="stampingBtnNext" icon={faCircleChevronRight} onClick={nextSlide} />
                    <FontAwesomeIcon className='stampingBtnClose' icon={faCircleXmark} onClickCapture={handleCloseModal} />
                    <img className="stampingFullScreen" src={listStamping[slideNumber].img} alt='imgStamping' />
                </div>
            }
            <div>
                <img className='img-custom-size img-fluid ms-2' src={logoStamping} alt='logoStamping' />
            </div>
            <div className="stampingGalleryWrap mx-2">

                {
                    listStamping && listStamping.map((image, index) => {
                        return (
                            <div
                                className="stampingSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="stamping" />

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">Back to Production Capabilities</button>
                </Link>
            </div>
        </div>
    )
}


export default StampingCapabilities